export default __webpack_public_path__ + "static/043-ecc9acacaedf705409157c1dea540be5.png";